import BaseStyle from '@primevue/core/base/style';

var classes = {
  root: 'p-fluid'
};
var FluidStyle = BaseStyle.extend({
  name: 'fluid',
  classes: classes
});

export { FluidStyle as default };
//# sourceMappingURL=index.mjs.map
